<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-toolbar flat color="white">
            <v-toolbar-title>Salary Events</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click.native.stop="dialog = true">New</v-btn>
        </v-toolbar>
        <DataTable
                ref="datatable"
                :url="this.api.ACTIONS.SALARY_EVENTS"
                :titles="titles"
                :fields-hidden-main="['updated_at','created_at','user','user_id']"
                :fields-extra-main="fieldsExtraMain"
                :enableEdit="false"
                :enable-add="false"
                :disable-search="true"
        />

        <v-dialog v-model="dialog" max-width="500">
            <v-card>
                <v-container>
                    <v-form ref="form" v-model="valid">
                        <p class="headline">Salary Event:</p>
                        <choose-user-multi :multi="false"
                                           v-model="model.user_id"
                                           label="Choose User"
                                           color="green"
                                           :rules="requiredRules"
                        />
                        <v-select :items="['BONUS','SALARY_ADVANCE','PENALTY']" v-model="model.type" label="Type"/>
                        <v-text-field v-model="model.amount" label="Amount"></v-text-field>
                        <choose-date v-model="model.date" label="Date"></choose-date>
                        <v-btn block color="primary" @click="submit">Submit</v-btn>

                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";
    import LoadingComponent from "@/components/LoadingComponent";


    export default {
        name: "SalaryEvents",
        title: "Salary Events",
        components: {LoadingComponent, ChooseDate, DataTable, ChooseUserMulti},
        data() {
            return {
                dialog: false,
                snackbar: false,
                message: "",
                valid: true,
                loading: false,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                model: {
                    user_id: null,
                    amount: null,
                    date: null,
                    type: null
                }
            }
        },
        methods: {
            submit() {
                this.loading = true;
                this.axios.post(this.api.ACTIONS.SALARY_EVENTS, this.model)
                    .then(res => {
                        window.getApp.$emit("SHOW_TOAST", "Saved!")
                        this.loading = false;
                        console.log(res.data.data);
                        this.$refs.datatable.addItemToTable(Object.assign(res.data.data), false);
                    })
                    .catch(({response}) => {
                        window.getApp.$emit("SHOW_TOAST", response.data.message, "red")
                    }).finally(() => this.dialog = false)
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    name: "Name",
                    date: "date",
                    amount: "Amount"
                }
            },
            fieldsExtraMain() {
                return {
                    name(val) {
                        return val.user.first_name + " " + val.user.last_name;
                    },
                }
            }
        }

    }
</script>

<style scoped>

</style>
